import React from "react";
import Button from "./Button";

import { Fade } from "react-reveal";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Modal
} from "reactstrap";
 

export default function Greeting() {
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <p className="greeting-text-p subTitle"> Hello , I'am </p>

              <h1 className="greeting-text">
                {" "}
          Takwa .C
              {" "}
              </h1>
              <p className="greeting-text-p subTitle">a passionate full stack Software engineer

with deep knowledge in AI , various skills in developmment field & a huge passion for design.</p>
              <div className="button-greeting-div">
                <Button text="Resume in Fr-Version" newTab={true} href="https://drive.google.com/file/d/1GKcdyawfn_CdNEAA--xhwAoVCuOx2VbQ/view?usp=sharing" />

              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            <img alt="code" src={require("../static/img/quote1.png")}></img>
          </div>
        </div>
      </div>
      <br></br>

      <br></br>
    </Fade>
  );
}



// WEBPACK FOOTER //
// ./src/components/Top.js